// @ts-nocheck
import { Search, X } from 'lucide-react';
import { cn } from '@/lib/utils';

type Props = {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
};

export const MobileSearchBar = ({
  value,
  onChange,
  placeholder = 'Buscar...',
  className,
}: Props) => {
  return (
    <div
      className={cn(
        'flex items-center gap-2 bg-muted rounded-xl px-3 h-11',
        className,
      )}
    >
      <Search className="h-4 w-4 text-muted-foreground shrink-0" />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        inputMode="search"
        className="flex-1 bg-transparent text-[15px] outline-none placeholder:text-muted-foreground"
      />
      {value && (
        <button
          onClick={() => onChange('')}
          className="h-6 w-6 rounded-full bg-foreground/10 flex items-center justify-center"
          aria-label="Limpar"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </div>
  );
};
